<template>
  <div class="c-table" ref="designerAvgTable">
    <!-- <Spin size="large" fix v-if="loading" /> -->
    <el-table
      class="common-el-table-styles"
      ref="table"
      border
      stripe
      v-loading="loading"
      :height="height"
      :data="data"
      :cell-class-name="setCellClassName"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="['peopleNum', 'workDay'].includes(col.key)">
            <div v-if="scope.row[`edit${col.key}`]">
              <Col span="21">
                <el-input
                  placeholder=""
                  v-model="scope.row[`new${col.key}`]"
                  @blur="inputTrim(`new${col.key}`, scope.row, false)"
                  style="width: 70px"
                ></el-input>
                <Button type="primary" :loading="saving" size="small" @click="editNum(scope.row)">
                  <span v-if="!saving">确定</span>
                </Button>
                <Button size="small" @click="cancelEdit(scope.row, `edit${col.key}`)">取消</Button>
              </Col>
            </div>
            <div v-else>
              <span v-if="scope.row[col.key] >= 0">{{ scope.row[col.key] }}</span>
              <Icon @click="changEdit(scope.row, `edit${col.key}`, col.key)" type="md-create" class="edit-icon" size="18" color="#409EFF" />
            </div>
          </div>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
      <template slot="empty">
        <no-data />
      </template>
    </el-table>
  </div>
</template>

<script>
import { isEmpty, trim } from '@/common/js/utils'
import { updateDesignerSumInfo } from '@/api/manage.model'

export default {
  name: 'designerAvgTable',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  data() {
    return {
      saving: false
    }
  },
  methods: {
    doLayout() {
      this.$refs.table.doLayout()
    },
    inputTrim(key, row, fixed) {
      let val = parseFloat(row[key])
      if (isEmpty(val) || typeof val !== 'number') {
        this.$set(row, key, 0)
        return
      }
      val = trim(val)
      if (fixed) {
        val = val * 100
        val = Math.floor(val) / 100
      } else val = parseInt(val)
      this.$set(row, key, val)
    },
    editNum(row) {
      const { month, peopleNum, newpeopleNum, workDay, newworkDay } = row
      const params = {
        month: `${month}-1`,
        peopleNum: newpeopleNum >= 0 ? newpeopleNum : peopleNum,
        workDay: newworkDay >= 0 ? newworkDay : workDay
      }
      this.saving = true
      updateDesignerSumInfo(params).then((data) => {
        this.saving = false
        if (data) {
          this.$Message.success('操作成功')
          this.$emit('on-refresh')
        }
      })
    },
    // 改变编辑状态
    changEdit(row, key, field) {
      let value = row[field]
      if (value < 0) value = 0
      this.data.forEach((ret) => {
        this.$set(ret, key, false)
      })
      this.$set(row, `new${field}`, value)
      this.$set(row, key, true)
    },
    cancelEdit(row, key) {
      this.saving = false
      this.$set(row, key, 0)
    },
    setCellClassName({ column }) {
      if (column.property === 'peopleNum') return 'people-num-col'
      if (column.property === 'workDay') return 'work-day-col'
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  .people-num-col,
  .work-day-col {
    position: relative;
    .edit-icon {
      position: absolute;
      right: 0;
      top: 5px;
      visibility: hidden;
    }

    &:hover {
      .edit-icon {
        visibility: visible;
      }
    }
  }
}
</style>
